<template>
    <img class="app-icon" :src="finalSrc" :alt="alt" :style="iconStyle" :loading="lazy ? 'lazy' : 'eager'" :decoding="decoding" :referrerpolicy="referrerPolicy" @error="onError" />
</template>

<script>
export default {
    name: "AppIcon",
    props: {
        src: { type: String, required: true },

        /* size: number (px) hoặc string ("1.5rem", "24px") */
        size: { type: [Number, String], default: 24 },

        /* nếu cần size riêng width/height */
        width: { type: [Number, String], default: null },
        height: { type: [Number, String], default: null },

        alt: { type: String, default: "" },
        fit: { type: String, default: "contain" }, // contain | cover
        radius: { type: [Number, String], default: 0 },

        /* tối ưu */
        lazy: { type: Boolean, default: true },
        decoding: { type: String, default: "async" }, // async | auto | sync

        /* khi lỗi ảnh */
        fallback: { type: String, default: "" }, // URL fallback nếu muốn

        /* tránh lỗi hotlink/cors trong vài trường hợp */
        referrerPolicy: { type: String, default: "no-referrer-when-downgrade" }
    },
    data() {
        return { failed: false };
    },
    computed: {
        finalSrc() {
            // Nếu lỗi và có fallback thì dùng fallback, còn không dùng src gốc
            return (this.failed && this.fallback) ? this.fallback : this.src;
        },
        iconStyle() {
            const toCss = (v) => (typeof v === "number" ? `${v}px` : v);

            const w = this.width != null ? toCss(this.width) : toCss(this.size);
            const h = this.height != null ? toCss(this.height) : toCss(this.size);
            const r = toCss(this.radius);

            return {
                width: w,
                height: h,
                objectFit: this.fit,
                borderRadius: r,
                display: "inline-block",
                verticalAlign: "middle"
            };
        }
    },
    methods: {
        onError() {
            // để tránh loop nếu fallback cũng lỗi
            if (!this.failed) this.failed = true;
        }
    }
};
</script>

<style scoped>
/* tránh icon bị co giãn do line-height */
.app-icon {
    max-width: 100%;
    max-height: 100%;
}
</style>
``